import { defineMessages } from 'react-intl';

export default defineMessages({
    payNow: {
        id: 'tdic.billing.authorize-payment.Proceed',
        defaultMessage: 'Proceed'
    }
});
